/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { changeAvailabilityChargePoint } from '../fn/charging/change-availability-charge-point';
import { ChangeAvailabilityChargePoint$Params } from '../fn/charging/change-availability-charge-point';
import { changeChargePointConfiguration } from '../fn/charging/change-charge-point-configuration';
import { ChangeChargePointConfiguration$Params } from '../fn/charging/change-charge-point-configuration';
import { ChargeActiveList } from '../models/charge-active-list';
import { ChargePagedList } from '../models/charge-paged-list';
import { ChargePoint } from '../models/charge-point';
import { ChargePointCompositeSchedule } from '../models/charge-point-composite-schedule';
import { ChargePointConfiguration } from '../models/charge-point-configuration';
import { ChargePointDriveResult } from '../models/charge-point-drive-result';
import { ChargePointList } from '../models/charge-point-list';
import { clearcacheChargePoint } from '../fn/charging/clearcache-charge-point';
import { ClearcacheChargePoint$Params } from '../fn/charging/clearcache-charge-point';
import { clearChargePointChargingProfile } from '../fn/charging/clear-charge-point-charging-profile';
import { ClearChargePointChargingProfile$Params } from '../fn/charging/clear-charge-point-charging-profile';
import { DrivableTagList } from '../models/drivable-tag-list';
import { getChargePoint } from '../fn/charging/get-charge-point';
import { GetChargePoint$Params } from '../fn/charging/get-charge-point';
import { getChargePointCompositeSchedule } from '../fn/charging/get-charge-point-composite-schedule';
import { GetChargePointCompositeSchedule$Params } from '../fn/charging/get-charge-point-composite-schedule';
import { getChargePointConfiguration } from '../fn/charging/get-charge-point-configuration';
import { GetChargePointConfiguration$Params } from '../fn/charging/get-charge-point-configuration';
import { getChargePoints } from '../fn/charging/get-charge-points';
import { GetChargePoints$Params } from '../fn/charging/get-charge-points';
import { getDrivableTags } from '../fn/charging/get-drivable-tags';
import { GetDrivableTags$Params } from '../fn/charging/get-drivable-tags';
import { getStationActiveCharges } from '../fn/charging/get-station-active-charges';
import { GetStationActiveCharges$Params } from '../fn/charging/get-station-active-charges';
import { resetChargePoint } from '../fn/charging/reset-charge-point';
import { ResetChargePoint$Params } from '../fn/charging/reset-charge-point';
import { searchStationCharges } from '../fn/charging/search-station-charges';
import { searchStationCharges$Any } from '../fn/charging/search-station-charges-any';
import { SearchStationCharges$Any$Params } from '../fn/charging/search-station-charges-any';
import { SearchStationCharges$Params } from '../fn/charging/search-station-charges';
import { setChargePointChargingProfile } from '../fn/charging/set-charge-point-charging-profile';
import { SetChargePointChargingProfile$Params } from '../fn/charging/set-charge-point-charging-profile';
import { setTagValue } from '../fn/charging/set-tag-value';
import { SetTagValue$Params } from '../fn/charging/set-tag-value';
import { startChargePointTransaction } from '../fn/charging/start-charge-point-transaction';
import { StartChargePointTransaction$Params } from '../fn/charging/start-charge-point-transaction';
import { stopChargePointTransaction } from '../fn/charging/stop-charge-point-transaction';
import { StopChargePointTransaction$Params } from '../fn/charging/stop-charge-point-transaction';
import { unlockChargePoint } from '../fn/charging/unlock-charge-point';
import { UnlockChargePoint$Params } from '../fn/charging/unlock-charge-point';


/**
 * All about charging point
 */
@Injectable({ providedIn: 'root' })
export class ChargingService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getChargePoints()` */
  static readonly GetChargePointsPath = '/stations/{uid}/chargepoints';

  /**
   * Get the chargepoints for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChargePoints()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePoints$Response(params: GetChargePoints$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointList>> {
    return getChargePoints(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the chargepoints for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChargePoints$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePoints(params: GetChargePoints$Params, context?: HttpContext): Observable<ChargePointList> {
    return this.getChargePoints$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePointList>): ChargePointList => r.body)
    );
  }

  /** Path part for operation `getChargePoint()` */
  static readonly GetChargePointPath = '/stations/{uid}/chargepoints/{chargePointUid}';

  /**
   * Get a chargepoint for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChargePoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePoint$Response(params: GetChargePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePoint>> {
    return getChargePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a chargepoint for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChargePoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePoint(params: GetChargePoint$Params, context?: HttpContext): Observable<ChargePoint> {
    return this.getChargePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePoint>): ChargePoint => r.body)
    );
  }

  /** Path part for operation `getDrivableTags()` */
  static readonly GetDrivableTagsPath = '/stations/{uid}/drive/tags';

  /**
   * Get the list of drivable tags.
   *
   * Gives the list of tag that the contacts can change the value of. Defined by the Pilotage row in the tag configuration table
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDrivableTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDrivableTags$Response(params: GetDrivableTags$Params, context?: HttpContext): Observable<StrictHttpResponse<DrivableTagList>> {
    return getDrivableTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the list of drivable tags.
   *
   * Gives the list of tag that the contacts can change the value of. Defined by the Pilotage row in the tag configuration table
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDrivableTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDrivableTags(params: GetDrivableTags$Params, context?: HttpContext): Observable<DrivableTagList> {
    return this.getDrivableTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<DrivableTagList>): DrivableTagList => r.body)
    );
  }

  /** Path part for operation `setTagValue()` */
  static readonly SetTagValuePath = '/stations/{uid}/drive/{tagUid}';

  /**
   * Set the value of a particular tag.
   *
   * Set the value of a particular tag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setTagValue()` instead.
   *
   * This method doesn't expect any request body.
   */
  setTagValue$Response(params: SetTagValue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setTagValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Set the value of a particular tag.
   *
   * Set the value of a particular tag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setTagValue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setTagValue(params: SetTagValue$Params, context?: HttpContext): Observable<void> {
    return this.setTagValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `resetChargePoint()` */
  static readonly ResetChargePointPath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/reset';

  /**
   * Reset a chargepoint.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetChargePoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetChargePoint$Response(params: ResetChargePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointDriveResult>> {
    return resetChargePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * Reset a chargepoint.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetChargePoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetChargePoint(params: ResetChargePoint$Params, context?: HttpContext): Observable<ChargePointDriveResult> {
    return this.resetChargePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePointDriveResult>): ChargePointDriveResult => r.body)
    );
  }

  /** Path part for operation `changeAvailabilityChargePoint()` */
  static readonly ChangeAvailabilityChargePointPath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/changeavailability/{connectorUid}';

  /**
   * Change availability of a connector.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeAvailabilityChargePoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  changeAvailabilityChargePoint$Response(params: ChangeAvailabilityChargePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointDriveResult>> {
    return changeAvailabilityChargePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * Change availability of a connector.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeAvailabilityChargePoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  changeAvailabilityChargePoint(params: ChangeAvailabilityChargePoint$Params, context?: HttpContext): Observable<ChargePointDriveResult> {
    return this.changeAvailabilityChargePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePointDriveResult>): ChargePointDriveResult => r.body)
    );
  }

  /** Path part for operation `clearcacheChargePoint()` */
  static readonly ClearcacheChargePointPath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/clearcache';

  /**
   * Clear cache on chargepoint.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clearcacheChargePoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  clearcacheChargePoint$Response(params: ClearcacheChargePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointDriveResult>> {
    return clearcacheChargePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * Clear cache on chargepoint.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clearcacheChargePoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clearcacheChargePoint(params: ClearcacheChargePoint$Params, context?: HttpContext): Observable<ChargePointDriveResult> {
    return this.clearcacheChargePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePointDriveResult>): ChargePointDriveResult => r.body)
    );
  }

  /** Path part for operation `unlockChargePoint()` */
  static readonly UnlockChargePointPath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/unlock/{connectorUid}';

  /**
   * Unlock a chargepoint connector.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unlockChargePoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  unlockChargePoint$Response(params: UnlockChargePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unlockChargePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlock a chargepoint connector.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unlockChargePoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unlockChargePoint(params: UnlockChargePoint$Params, context?: HttpContext): Observable<void> {
    return this.unlockChargePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `startChargePointTransaction()` */
  static readonly StartChargePointTransactionPath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/start/{connectorUid}';

  /**
   * Start a new charging transaction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startChargePointTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  startChargePointTransaction$Response(params: StartChargePointTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return startChargePointTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * Start a new charging transaction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startChargePointTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startChargePointTransaction(params: StartChargePointTransaction$Params, context?: HttpContext): Observable<void> {
    return this.startChargePointTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `stopChargePointTransaction()` */
  static readonly StopChargePointTransactionPath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/stop/{transactionId}';

  /**
   * Stop a charging transaction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stopChargePointTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  stopChargePointTransaction$Response(params: StopChargePointTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return stopChargePointTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * Stop a charging transaction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stopChargePointTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stopChargePointTransaction(params: StopChargePointTransaction$Params, context?: HttpContext): Observable<void> {
    return this.stopChargePointTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getChargePointConfiguration()` */
  static readonly GetChargePointConfigurationPath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/getconfiguration';

  /**
   * Get configuration for a charge point.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChargePointConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePointConfiguration$Response(params: GetChargePointConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointConfiguration>> {
    return getChargePointConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Get configuration for a charge point.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChargePointConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePointConfiguration(params: GetChargePointConfiguration$Params, context?: HttpContext): Observable<ChargePointConfiguration> {
    return this.getChargePointConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePointConfiguration>): ChargePointConfiguration => r.body)
    );
  }

  /** Path part for operation `getChargePointCompositeSchedule()` */
  static readonly GetChargePointCompositeSchedulePath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/getcompositeschedule/{connectorUid}';

  /**
   * Get report of Composite Charging Schedule for a connector of a charge point.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChargePointCompositeSchedule()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePointCompositeSchedule$Response(params: GetChargePointCompositeSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointCompositeSchedule>> {
    return getChargePointCompositeSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * Get report of Composite Charging Schedule for a connector of a charge point.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChargePointCompositeSchedule$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePointCompositeSchedule(params: GetChargePointCompositeSchedule$Params, context?: HttpContext): Observable<ChargePointCompositeSchedule> {
    return this.getChargePointCompositeSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePointCompositeSchedule>): ChargePointCompositeSchedule => r.body)
    );
  }

  /** Path part for operation `setChargePointChargingProfile()` */
  static readonly SetChargePointChargingProfilePath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/setchargingprofile/{connectorUid}';

  /**
   * Set charging profile for a transaction or a charge point globally.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setChargePointChargingProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setChargePointChargingProfile$Response(params: SetChargePointChargingProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setChargePointChargingProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Set charging profile for a transaction or a charge point globally.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setChargePointChargingProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setChargePointChargingProfile(params: SetChargePointChargingProfile$Params, context?: HttpContext): Observable<void> {
    return this.setChargePointChargingProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changeChargePointConfiguration()` */
  static readonly ChangeChargePointConfigurationPath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/changeconfiguration';

  /**
   * Change configuration for a charge point.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeChargePointConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeChargePointConfiguration$Response(params: ChangeChargePointConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changeChargePointConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Change configuration for a charge point.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeChargePointConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeChargePointConfiguration(params: ChangeChargePointConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.changeChargePointConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clearChargePointChargingProfile()` */
  static readonly ClearChargePointChargingProfilePath = '/stations/{uid}/drive/chargepoints/{chargePointUid}/clearchargingprofile/{connectorUid}';

  /**
   * Clear all charging profile for a charge point.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clearChargePointChargingProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clearChargePointChargingProfile$Response(params: ClearChargePointChargingProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clearChargePointChargingProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Clear all charging profile for a charge point.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clearChargePointChargingProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clearChargePointChargingProfile(params: ClearChargePointChargingProfile$Params, context?: HttpContext): Observable<void> {
    return this.clearChargePointChargingProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStationActiveCharges()` */
  static readonly GetStationActiveChargesPath = '/stations/{uid}/charges/active';

  /**
   * Get all the active charges for a station.
   *
   * Get all active charges for a station.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationActiveCharges()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationActiveCharges$Response(params: GetStationActiveCharges$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargeActiveList>> {
    return getStationActiveCharges(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all the active charges for a station.
   *
   * Get all active charges for a station.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationActiveCharges$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationActiveCharges(params: GetStationActiveCharges$Params, context?: HttpContext): Observable<ChargeActiveList> {
    return this.getStationActiveCharges$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargeActiveList>): ChargeActiveList => r.body)
    );
  }

  /** Path part for operation `searchStationCharges()` */
  static readonly SearchStationChargesPath = '/stations/{uid}/charges/search';

  /**
   * Search charges for a station.
   *
   * Search charges for a station.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationCharges()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationCharges$Response(params: SearchStationCharges$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePagedList>> {
    return searchStationCharges(this.http, this.rootUrl, params, context);
  }

  /**
   * Search charges for a station.
   *
   * Search charges for a station.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationCharges$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationCharges(params: SearchStationCharges$Params, context?: HttpContext): Observable<ChargePagedList> {
    return this.searchStationCharges$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePagedList>): ChargePagedList => r.body)
    );
  }

  /**
   * Search charges for a station.
   *
   * Search charges for a station.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationCharges$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationCharges$Any$Response(params: SearchStationCharges$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePagedList>> {
    return searchStationCharges$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search charges for a station.
   *
   * Search charges for a station.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationCharges$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationCharges$Any(params: SearchStationCharges$Any$Params, context?: HttpContext): Observable<ChargePagedList> {
    return this.searchStationCharges$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePagedList>): ChargePagedList => r.body)
    );
  }

}
